module.exports = __webpack_public_path__ + "img/start-page-preview.0cdc7b3d.png";